import React, { Component } from 'react';
import ModalVideo from 'react-modal-video'
import {Link} from 'react-router-dom';

class VideoCta extends Component{

    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
      }
     
      openModal () {
        this.setState({isOpen: true})
      }
    render(){
        return(
            <div>
                {/*====================  video cta area ====================*/}
                <div className="video-cta-area section-space--inner--120">
                    <div className="container">
                        <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <div className="video-cta-content">
                            <h4 className="video-cta-content__small-title">ABOUT US</h4>
                            <h3 className="video-cta-content__title">Welcome to City Fort</h3>
                            <p className="video-cta-content__text">City Fort Contracting L.L.C. was established in UAE in 2007 as a Limited Liability Company and registered with Dubai Economic Department under Trade License Nr. 592673 to perform the following activities:
Buildings Contracting
Sewerage and Drainage Works
Roads & Infrastructure Works</p>
                            <Link to={`${process.env.PUBLIC_URL}/about-us`} className="ht-btn ht-btn--round">Learn More</Link>
                            </div>
                        </div>
                        <div className="col-lg-5 offset-lg-1 col-md-6">
                            <div className="cta-video-image">
                            <div className="video-popup">
                            <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='o8jWLHeXZ8I' onClose={() => this.setState({isOpen: false})} />
                                <button onClick={this.openModal}>
                                    <div className="cta-video-image__image">
                                        <img src="https://cityfort.ae/images/ewfile12.jpg" className="img-fluid" alt="" />
                                    </div>
                                    <div className="cta-video-image__icon">
                                        <i className="ion-ios-play" />
                                    </div>
                                </button>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                {/*====================  End of video cta area  ====================*/}
            </div>
        )
    }
}


export default VideoCta;